import Vue from 'vue';
import App from './app.vue';
import router from './router';
import store from './store';
import i18n from './plugins/i18n';
import './plugins/injectable';
import './app/shared/filters/filters';
import sendevent from 'sendevent';
import './plugins/dayjs';
import './plugins/videojs';
import './plugins/bootstrap-vue';
import './plugins/highlightjs'
import './plugins/sanitize'
import * as jQuery from 'jquery';
(window as any).$ = jQuery;

import { resolve } from '@/app/container';
import { container } from './app/container/container';
import { loadContainerModules } from './app/di.root';
import { LayoutService, LayoutServiceSymbol } from '@/app/layout/layout-service';
import { setDocumentLanguage } from '@/app/locale/locale-utils';
import { Route } from 'vue-router';
import rootStoreModule from '@/app/shared/state/root';
import { configureErrorReporting } from '@/app/error-reporting';
import { setDocumentTitle } from './app/shared/utils/document-utils';
import { resolveVersion } from './app/version';
import { DEFAULT_LOCALE } from './locales/default-locale';

import '@THEME_FONTS'; // Webpack alias for theme fonts

Vue.config.productionTip = false;

const version = resolveVersion()
console.info(`Starting ${version.release}...`)

configureErrorReporting()

setDocumentTitle()
setDocumentLanguage(DEFAULT_LOCALE);

loadContainerModules(container)

const layoutService: LayoutService = resolve<LayoutService>(LayoutServiceSymbol);
layoutService.init().then(() => {
  const vueApp = new Vue({
    router,
    store,
    i18n,
    render: (h: any) => h(App)
  })
  vueApp.$mount('#app');
});

Vue.mixin({
  beforeRouteLeave(to: Route, from: Route, next: any) {
    rootStoreModule.setIsFirstLoad(false);

    next();
  }
});

sendevent('/reload-events', () => {
  window.location.reload();
});
